<div class="free-input-text-editor">

  <!-- Material -->
  <section class="material-section">
    <h3 class="section-title">{{ 'freeInputText.materialSection' | transloco }}</h3>
    <mat-form-field class="material-tab-name-field">
      <mat-label>{{ 'freeInputText.materialTabLabel' | transloco }}</mat-label>
      <input matInput [(ngModel)]="materialTabName" placeholder="Material" />
    </mat-form-field>
    <div class="editor-wrapper">
      <pixl-editor
        [htmlString]="part().markup ?? ''"
        [editorHeight]="'300px'"
        [bearerToken]="authToken() ?? ''"
        [assetUrl]="assetsUrl()"
        [mediaUrl]="mediaUrl()"
        (callbackFct)="onMarkupChange($event)"
        [fixedMenu]="true"
        [primaryColor]="playerSettings()?.theme?.primaryColor ?? null"
        [secondaryColor]="playerSettings()?.theme?.secondaryColor ?? null"
        [tertiaryColor]="playerSettings()?.theme?.tertiaryColor ?? null"
        [placeholderColor]="playerSettings()?.theme?.placeholderColor ?? null"
        [hoverColor]="playerSettings()?.theme?.hoverColor ?? null"
        [drawColor]="playerSettings()?.theme?.drawColor ?? null"
        [drawHighlightColor]="playerSettings()?.theme?.drawHighlightColor ?? null"
        [compareSolutionsBgColor]="playerSettings()?.theme?.compareSolutionsBgColor ?? null"
      ></pixl-editor>
    </div>
  </section>

  <!-- Items -->
  <section class="items-section">
    <div class="items-toolbar">
      <button mat-button (click)="collapseAll()">
        <mat-icon>unfold_less</mat-icon>
        {{ 'freeInputText.collapseAll' | transloco }}
      </button>
      <button mat-button (click)="expandAll()">
        <mat-icon>unfold_more</mat-icon>
        {{ 'freeInputText.expandAll' | transloco }}
      </button>
      <span class="syntax-hint">{{ 'freeInputText.syntaxHint' | transloco }}</span>
    </div>

    <div cdkDropList (cdkDropListDropped)="onDrop($event)" class="items-drop-list">
      @for (item of part().items; track item.id; let i = $index) {
        <div class="item-row" cdkDrag>
          <div class="item-header">
            <mat-icon class="drag-handle" cdkDragHandle>drag_indicator</mat-icon>
            <input
              class="item-text-input"
              [ngModel]="item.text"
              (ngModelChange)="onItemTextChange(item, $event)"
              [placeholder]="'freeInputText.itemTextPlaceholder' | transloco"
            />
            <mat-checkbox
              [checked]="isInputField(item)"
              (change)="setInputField(item, $event.checked)"
            >
              {{ 'freeInputText.inputField' | transloco }}
            </mat-checkbox>
            <button mat-icon-button (click)="toggleItem(item.id)">
              <mat-icon>{{ expandedItems.has(item.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
            <button mat-icon-button (click)="removeItem(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          @if (expandedItems.has(item.id)) {
            <div class="item-detail">
              <mat-form-field class="full-width">
                <mat-label>{{ 'freeInputText.hint' | transloco }}</mat-label>
                <textarea matInput [ngModel]="item.hint ?? ''" (ngModelChange)="onItemHintChange(item, $event)" rows="2"></textarea>
              </mat-form-field>

              <mat-form-field class="full-width">
                <mat-label>{{ 'freeInputText.perfectSolution' | transloco }}</mat-label>
                <textarea matInput [ngModel]="item.perfectSolution ?? ''" (ngModelChange)="onItemPerfectSolutionChange(item, $event)" rows="2"></textarea>
              </mat-form-field>

              @if (kiService()) {
                <div class="ki-section">
                  <mat-checkbox [checked]="isNlpDisabled(item)" (change)="setNlpDisabled(item, $event.checked)">
                    {{ 'freeInputText.kiDisabled' | transloco }}
                  </mat-checkbox>

                  <mat-checkbox [checked]="isNlpContext(item)" (change)="setNlpContext(item, $event.checked)" matTooltip="{{ 'freeInputText.nlpContextTooltip' | transloco }}" matTooltipPosition="above" matTooltipPositionAtOrigin>
                    {{ 'freeInputText.nlpContext' | transloco }}
                  </mat-checkbox>

                  <mat-form-field class="threshold-field" matTooltip="{{ 'freeInputText.difficultyTooltip' | transloco }}" matTooltipPosition="above" matTooltipPositionAtOrigin>
                    <mat-label>{{ 'freeInputText.difficulty' | transloco }}</mat-label>
                    <input matInput type="number" min="0" max="1" step="0.01" [ngModel]="getNlpThreshold(item)" (ngModelChange)="setNlpThreshold(item, $event)" />
                  </mat-form-field>

                  <button mat-button (click)="toggleKiOptions(item.id)">
                    <mat-icon>{{ expandedKiOptions.has(item.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
                    {{ 'freeInputText.kiOptions' | transloco }}
                  </button>

                  @if (expandedKiOptions.has(item.id)) {
                    @if (!lastNlpResult()) {
                      <p class="ki-options-hint">{{ 'freeInputText.kiOptionsHint' | transloco }}</p>
                    } @else {
                      <div class="ki-options">
                        @if (componentKeys().length > 0) {
                          <div class="nlp-group">
                            <h4 class="nlp-group-title">{{ 'freeInputText.nlpComponents' | transloco }}</h4>
                            @for (key of componentKeys(); track key) {
                              <mat-checkbox [checked]="isComponentEnabled(key)" (change)="toggleComponent(key, $event.checked)">{{ key }}</mat-checkbox>
                            }
                          </div>
                        }
                        @if (categoryKeys().length > 0) {
                          <div class="nlp-group">
                            <h4 class="nlp-group-title">{{ 'freeInputText.nlpCategories' | transloco }}</h4>
                            @for (key of categoryKeys(); track key) {
                              <mat-checkbox [checked]="isCategoryEnabled(key)" (change)="toggleCategory(key, $event.checked)">{{ key }}</mat-checkbox>
                            }
                          </div>
                        }
                        <mat-form-field class="full-width">
                          <mat-label>{{ 'freeInputText.nlpContentMatching' | transloco }}</mat-label>
                          <mat-select [ngModel]="contentMatchingBasedOn()" (ngModelChange)="setContentMatchingBasedOn($event)">
                            <mat-option value="lemma">{{ 'freeInputText.nlpContentMatchingLemma' | transloco }}</mat-option>
                            <mat-option value="token">{{ 'freeInputText.nlpContentMatchingToken' | transloco }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                        <mat-checkbox [checked]="useExerciseTextAsLexicon()" (change)="setUseExerciseTextAsLexicon($event.checked)">
                          {{ 'freeInputText.nlpUseExerciseText' | transloco }}
                        </mat-checkbox>
                        <div class="nlp-group">
                          <h4 class="nlp-group-title">{{ 'freeInputText.nlpIgnoredCodes' | transloco }}</h4>
                          @if (ignoredCodes().length > 0) {
                            <div class="ignored-codes-list">
                              @for (code of ignoredCodes(); track code) {
                                <div class="ignored-code-item">
                                  <span>{{ code }}</span>
                                  <button mat-icon-button (click)="removeIgnoreCode(code)"><mat-icon>close</mat-icon></button>
                                </div>
                              }
                            </div>
                          }
                          @if (availableCodesToAdd().length > 0) {
                            <div class="available-codes">
                              @for (code of availableCodesToAdd(); track code) {
                                <button mat-stroked-button (click)="addIgnoreCode(code)"><mat-icon>add</mat-icon>{{ code }}</button>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>

    <button mat-raised-button (click)="addItem()" class="add-item-btn">
      <mat-icon>add</mat-icon>
      {{ 'freeInputText.addItem' | transloco }}
    </button>
  </section>

</div>
